import { css } from 'lit';

export default [
  css`
  .dropdown-button {
    padding: var(--tenable-dropdown-padding, .5rem 2rem .5rem .5rem);
    border: var(--tenable-dropdown-border, 1px solid #dadfe1);
    border-radius: var(--tenable-dropdown-border-radius, 4px);
    cursor: pointer;
    position: relative;
  }

  .dropdown-icon {
    position: absolute;
    top: var(--tenable-dropdown-icon-top-padding, .70rem);
    right: var(--tenable-dropdown-icon-right-padding, .5rem);
  }

  .dropdown-body {
    position: absolute;
    display: block;
    z-index: 1000;
    overflow-y: scroll;
    border: var(--tenable-dropdown-body-border, 1px solid rgba(0,0,0,.1));
    border-radius: var(--tenable-dropdown-body-border-radius, 4px);
    padding: var(--tenable-dropdown-body-padding, .7rem 0rem 0rem 0rem);
    background: var(--tenable-dropdown-body-background, #fff);
    max-height: var(--tenable-dropdown-max-height, 500px);
    box-shadow: var(--tenable-dropdown-box-shadow, 0 5px 10px rgba(0,0,0,.05),0 2px 6px rgba(0,0,0,.025),0 1px 3px rgba(0,0,0,.025));
  }
  `,
];
